import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Box, ShadowBox, Checkbox } from '@components/common';
import { Field } from 'formik';
import {
  StripeExpiryField,
  StripeCVCField,
  StripeCardField
} from '@components/form';
import SlideToggleContent from '@components/SlideToggleContent';
import TableCell from '@components/TableCell';
import { AuthSelectors } from '@redux/AuthRedux';

const PAYMENT_METHODS = {
  CREDIT: 'credit',
  INVOICE: 'invoice'
};

const Wrapper = styled(Box)`
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
`;

function PaymentSelection(props) {
  const {
    isPMUser,
    user,
    hasPaymentMethod,
    selectedMethod,
    onChange,
    ...restProps
  } = props;
  const { ccLast4, ccBrand } = user;

  const isVisible = selectedMethod === PAYMENT_METHODS.CREDIT;

  const handleOnChange = (e, value) => {
    e.preventDefault();
    e.stopPropagation();
    onChange(value);
  };

  const renderPaymentForm = () => {
    return (
      <Wrapper px={4} pt={4}>
        <Field component={StripeCardField} mb={4} name="cardNumValid" />
        <Box flexDirection="row" display="flex" justifyContent="space-between">
          <Field
            component={StripeExpiryField}
            mr={4}
            mb={4}
            name="cardExpValid"
          />
          <Field component={StripeCVCField} mb={4} name="cardCVCValid" />
        </Box>
      </Wrapper>
    );
  };

  return (
    <ShadowBox {...restProps}>
      {hasPaymentMethod && (
        <TableCell
          title={`${ccBrand} ending in ${ccLast4}`}
          renderAccessories={() => {
            if (!isPMUser) {
              return null;
            }
            return (
              <label>
                <Checkbox
                  checked={selectedMethod === PAYMENT_METHODS.CREDIT}
                  mb={0}
                  variant="radio"
                  onChange={e => {
                    handleOnChange(e, PAYMENT_METHODS.CREDIT);
                  }}
                />
              </label>
            );
          }}
        />
      )}
      {!hasPaymentMethod && (
        <React.Fragment>
          <TableCell
            title="Credit Card"
            renderAccessories={() => {
              if (!isPMUser) {
                return null;
              }
              return (
                <label>
                  <Checkbox
                    checked={selectedMethod === PAYMENT_METHODS.CREDIT}
                    mb={0}
                    variant="radio"
                    onChange={e => {
                      handleOnChange(e, PAYMENT_METHODS.CREDIT);
                    }}
                  />
                </label>
              );
            }}
          />
          <SlideToggleContent isVisible={isVisible}>
            {renderPaymentForm()}
          </SlideToggleContent>
        </React.Fragment>
      )}

      {isPMUser && (
        <TableCell
          title="Invoice"
          renderAccessories={() => (
            <label>
              <Checkbox
                checked={selectedMethod === PAYMENT_METHODS.INVOICE}
                mb={0}
                variant="radio"
                onChange={e => {
                  handleOnChange(e, PAYMENT_METHODS.INVOICE);
                }}
              />
            </label>
          )}
        />
      )}
    </ShadowBox>
  );
}

PaymentSelection.propTypes = {
  hasPaymentMethod: PropTypes.bool,
  isPMUser: PropTypes.bool,
  user: PropTypes.object,
  selectedMethod: PropTypes.string,
  onChange: PropTypes.func
};

PaymentSelection.defaultProps = {
  selectedMethod: PAYMENT_METHODS.CREDIT
};

const mapStatesToProps = state => ({
  isPMUser: AuthSelectors.selectIsPMUser(state),
  hasPaymentMethod: AuthSelectors.selectHasPaymentMethod(state),
  user: AuthSelectors.selectCurrentUser(state)
});

export default connect(mapStatesToProps)(PaymentSelection);
